import { renderStartupFailure } from '@hkm/features/app/behaviours/renderStartupFailure';
import { register } from '@hkm/serviceWorkerRegistration';
import { Console } from '@hkm/utils/console';

interface Env {
  AC_ENV: { APP_REMOTE: string };
}

async function loadConfig(): Promise<void> {
  if ((window as unknown as Env).AC_ENV.APP_REMOTE === 'true') {
    await import('./../src/ac-config.json').then((Config) => {
      window.acConfig = Config.default;
    });
  } else {
    await import('@ac/library-utils/dist/utils/ac-config').then(
      ({ fetchAcConfig }) => {
        return fetchAcConfig();
      }
    );
  }
}

loadConfig()
  .then(async () => {
    const { init } = await import('./init');

    await register();
    await init();
  })
  .catch((error: unknown): void => {
    void Console.error(error);
    renderStartupFailure();
  });

export {};
